export enum ProductTypeValues {
  Simple = 'SIMPLE',
  Addition = 'ADDITION',
  Declinable = 'DECLINABLE',
}
